// extracted by mini-css-extract-plugin
export var blockedMessage = "_62-3";
export var blockedOverlay = "_62-1";
export var fadeIn = "_62-2";
export var hereLink = "_62-0";
export var slideUp = "_62-4";